import { useMemo } from 'react';
import { useProposalRecordHeader } from './useProposalRecordHeader';
/** Proposal sidebar counts (§4.3), from GetProposalRecordHeader. A 0 renders no badge. */ export function useProposalNavCounts(projectId) {
    const counts = useProposalRecordHeader(projectId).data?.counts;
    return useMemo(()=>counts ? {
            compliance: counts.requirements,
            clins: counts.clins,
            lcats: counts.lcats,
            files: counts.files,
            amendments: counts.amendments,
            reviews: counts.openReviews,
            documents: counts.documents,
            pursuit: counts.carriedIn
        } : {}, [
        counts
    ]);
}
